import React from 'react'
import ContentLoader from 'react-content-loader'

/** Generated with http://danilowoz.com/create-content-loader/ */

const ScrollListWithTitlePlaceholder = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={120}
    viewBox="0 0 400 120"
    backgroundColor="#e6e6e6"
    foregroundColor="#cdcdcd"
  >
    <rect x="117" y="15" rx="3" ry="3" width="140" height="16" />
    <rect x="9" y="108" rx="3" ry="3" width="50" height="10" />
    <circle cx="34" cy="71" r="26" />
    <circle cx="110" cy="71" r="26" />
    <rect x="87" y="108" rx="3" ry="3" width="48" height="10" />
    <circle cx="186" cy="71" r="26" />
    <rect x="158" y="108" rx="3" ry="3" width="56" height="10" />
    <circle cx="262" cy="71" r="26" />
    <rect x="239" y="108" rx="3" ry="3" width="48" height="10" />
    <circle cx="338" cy="71" r="26" />
    <rect x="315" y="108" rx="3" ry="3" width="48" height="10" />
  </ContentLoader>
)

export default ScrollListWithTitlePlaceholder
